import {Component, OnInit, ViewChild} from '@angular/core';
import { ButtonColumnType, CustomTableComponent, DataColumnType, ICustomTable, LoadingPanelService } from 'lib-base';
import { TramRegistroSolicitudService } from '../../../../services/tramiteRegistroSolicitud.service';
import { IGetTramitesSolicitudUsuario } from '../../../../shared/interfaces/liquidacion';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom, forkJoin } from 'rxjs';
import { TramiteSolicitudEstados } from '../../../../shared/enums/TramiteSolicitudEstados';
import { ProcesarTramiteComponent } from '../../procesar-tramite/procesar-tramite.component';
import {ImpuestosFuente} from "../../../../../../../lib-base/src/lib/shared";
import {ConfirmationService, MessageService} from "primeng/api";
import {ConfirmPopupModule} from "primeng/confirmpopup";

@Component({
  selector: 'app-tareas-pendientes',
  standalone: true,
  imports: [CustomTableComponent, ProcesarTramiteComponent, ConfirmPopupModule],
  providers: [ConfirmationService],
  templateUrl: './tareas-pendientes.component.html',
  styleUrl: './tareas-pendientes.component.scss'
})
export class TareasPendientesComponent implements OnInit {

  trans: any = {};
  size: number = 7;
  customTable !: ICustomTable;

  @ViewChild(CustomTableComponent) customTableComponent !: CustomTableComponent;
  @ViewChild(ProcesarTramiteComponent) _procesarTramite !: ProcesarTramiteComponent;

  constructor(private _trs: TramRegistroSolicitudService, private _t: TranslateService,
              private _lps: LoadingPanelService, private _m:MessageService,
              private _cs: ConfirmationService ) {

  }

  ngOnInit(): void {
    this.translate();
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      tramite: this._t.get('common.tramite'),
      radicado: this._t.get('common.radicado'),
      estado: this._t.get('common.estado'),
      fechaSolicitud: this._t.get('common.fecha-solicitud'),
      noHayRegistros: this._t.get('msg.no-hay-registros'),
      dependencia: this._t.get('common.dependencia'),
      finalizar: this._t.get('form.button.finalizar'),
      renaudar: this._t.get('common.renaudar'),
      cancelar: this._t.get('form.button.cancelar'),
      messageWarn: this._t.get('components.app-tareas-pendientes.message-warn'),
      messageInfo: this._t.get('components.app-tareas-pendientes.msg-info-desactivado'),
      titleWarn: this._t.get('form.msg.warn-summary'),
      titleSucces: this._t.get('form.msg.success-summary'),
      estaSeguroEliminar: this._t.get('components.app-tareas-pendientes.msg-desactivar'),
    }));
    this.configureColumns();
  }

  private configureColumns() {
    this.customTable = {
      columns: [
        {
          field: 'radicado',
          header: this.trans.radicado,
          sort: true,
          class:'font-13',
          style: {color:'#0077CC'},
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
          },
          columnFilter: true,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'tramite',
          header: this.trans.tramite,
          sort: true,
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
          },
          columnFilter: true,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'dependencia',
          header: this.trans.dependencia,
          sort: true,
          class:'brand-table-tag mx-auto my-auto font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
          },
          columnFilter: true,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'estado',
          header: this.trans.estado,
          sort: true,
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
          },
          columnFilter: false,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'fechaSolicitud',
          header: this.trans.fechaSolicitud,
          sort: true,
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
          },
          dataType: DataColumnType.DATE
        },
        {
          field: 'abrir',
          header: '',
          label: this.trans.renaudar,
          icon: 'pi pi-folder-open',
          class: 'button-edit p-button-outlined pt-2 pb-2',
          width: '0rem',
          buttonType: ButtonColumnType.CUSTOM,
          onClick: (event: Event, data: IGetTramitesSolicitudUsuario) => this.renaudar(data),
        }, {
          field: 'cancelar',
          header: '',
          label: this.trans.cancelar,
          icon: 'pi pi-times',
          class: 'button-edit p-button-outlined p-button-danger pt-2 pb-2',
          width: '0rem',
          buttonType: ButtonColumnType.CUSTOM,
          onClick: (event: Event, data: IGetTramitesSolicitudUsuario) => this.deseaEliminar(event,data),
        },
      ],
      settings: {
        table: {
          rows: this.size,
        }
      }
    } as ICustomTable;
  }

  //#region API Calls

  getTramites(renaudarSolicitudId?: number) {
    this._trs.getTramitesSolicitudUsuario().subscribe({
      next: (response: IGetTramitesSolicitudUsuario[]) => {
        this.customTableComponent.data = response;
      }
    });
  }

  async renaudar(data: IGetTramitesSolicitudUsuario) {
    this._lps.show();
    switch (data.estadoInternalName) {
      case TramiteSolicitudEstados.FIRMA_PENDIENTE:
        await firstValueFrom(this._trs.getInfoRecaudoTramite(data.id))
          .then(response => {
            this._procesarTramite.requierePago = response.requierePago;
            if (response.requierePago && response.fuentePago)
              this._procesarTramite.fuentePago = response.fuentePago;
            this._lps.hide();
            this._procesarTramite.showEnviarTokenFirmaElectronica(data.id);
          })
          .catch(err=> {
            this._lps.hide();
            this._procesarTramite.getMessageWarn(this.trans.messageWarn,this.trans.titleWarn);
          })
        break;
      case TramiteSolicitudEstados.PAGO_PENDIENTE:
        await this.requierePagoYFuentePago(data.id).then((response: string) => {
          switch (response) {
            case ImpuestosFuente.TRIBUTOS:
              this._procesarTramite.redireccionPagosExternos(data.id).then();
              break;
            case ImpuestosFuente.TRAMITES:
              this._procesarTramite.redirectToConsultaPagos(data.id);
              this._lps.hide();
              break;
          }
        });
        break;
      default:
        console.log('The status is not recognized.');
        this._procesarTramite.getMessageWarn(this.trans.messageWarn,this.trans.titleWarn);
        break;
    }
  }
  //#endregion

  deseaEliminar(event:any, data:IGetTramitesSolicitudUsuario){
      this._cs.confirm({
        target: event.target as EventTarget,
        message: this.trans.estaSeguroEliminar,
        icon: 'pi pi-exclamation-triangle',
        accept: () => this.desactivar(data)
      })
  }

  private desactivar(data:IGetTramitesSolicitudUsuario){
    this._lps.show();
      this._trs.cancelarSolicitud(data.id).subscribe({
        next:() => {
          this._lps.hide();
          this._m.add({severity: 'info', summary: this.trans.titleSucces, detail:this.trans.messageInfo})
          this.getTramites();
        }, error: () => {
          this._lps.hide();
        }
      })
  }

  //verifica si requiere pago y si tiene fuente de pago
  private async requierePagoYFuentePago(tramRegistroSolicitudId: number): Promise<string> {
    return await firstValueFrom(this._trs.hasFuentePago(tramRegistroSolicitudId)).then()
  }
}
